import angular from 'angular';

const facetsServices = angular.module('applicationModule.facetsServices', []);

facetsServices.factory('Facets', ['FacetsAPI', function (FacetsAPI) {
    'use strict';
    return {
        getList: function (appId, params) {
            return FacetsAPI.getList(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },

        get: function (facetId, appId) {
            return FacetsAPI.get(facetId, appId);
        },
        post: function (facet) {
            return FacetsAPI.createFacet(facet);
        },
        save: function (facet, editMode) {
            if (editMode) {
                return FacetsAPI.editFacet(facet);
            } else {
                return FacetsAPI.createFacet(facet);
            }
        },
        remove: function (facetId) {
            return FacetsAPI.remove(facetId);
        },
        searchFacets: function (appId, facetId, search, group) {
            return FacetsAPI.searchFacets(appId, facetId, search, group);
        },
        changeOrder: function (data) {
            return FacetsAPI.changeOrder(data);
        },
        copy: function (facetId) {
            return FacetsAPI.copy(facetId);
        }
    };
}]);

facetsServices.service('FacetsAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';
    const FACET_URL = AppsoupAPI.API_URL + '/app/facets/';

    this.getList = function (appId, params) {
        return $http.get(FACET_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {app_id: appId})});
    };

    this.get = function (facetId, appId) {
        return $http.get(FACET_URL + facetId, {params: {app_id: appId}});
    };

    this.createFacet = function (facet) {
        return $http.post(FACET_URL, facet);
    };

    this.editFacet = function (facet) {
        return $http.put(FACET_URL + 'update/' + facet.id, facet);
    };

    this.remove = function (facetId) {
        return $http.delete(FACET_URL + facetId);
    };

    this.searchFacets = function (appId, facetId, search, group) {
        return $http.get(FACET_URL + appId + '/' + facetId + '/all', {params: {search: search, group: group}});
    };

    this.changeOrder = function (data) {
        const url = FACET_URL + 'change-order/';

        return $http.post(url, data);
    };

    this.copy = function (facetId) {
        return $http.get(FACET_URL + 'copy/' + facetId);
    };

}]);

export default facetsServices;
